import React from 'react';

import { AvatarPreview } from '../wizard';
import { PlayerRank } from '../../types/scoreboard';
import { PlayerContext } from '../../contexts/player';

const PlayerScore = ({
  name,
  avatarImage,
  playerRank,
  playerTotal,
  isShowScore
}: Omit<PlayerRank, 'score'>) => {
  const [player] = React.useContext(PlayerContext);

  const score = player.playerState?.score ?? 0;
  return (
    <div id={'leaderboard'} className={'bg-light w-100 my-2 py-2'}>
      <AvatarPreview avatarSource={avatarImage} isShowPencil={false} />
      <div className={'text-center py-2'}>
        <h4>
          <strong>{name}</strong>
        </h4>
        {isShowScore && (
          <h1>
            <strong>{score}</strong>
          </h1>
        )}
        <h3>{`${playerRank}/${playerTotal}`}</h3>
      </div>
    </div>
  );
};

export default PlayerScore;
